export default "__VITE_ASSET__CJgrJKB$__"